"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationReferralRule',
  data: function data() {
    return {
      loading: false,
      list: []
    };
  },
  created: function created() {
    this.reload();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        publish: '发布',
        unpublish: '下架'
      }[value] || value;
    },
    reload: function reload() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationReferralRuleListApi)({
        page: 1,
        limit: 50
      }).then(function (data) {
        _this.list = data.list || [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('规则标题', '新增推荐规则').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationReferralRuleSaveApi)({
          title: value || 'E2E推荐规则',
          targetType: 'peer',
          rewardAmount: 50
        }).then(function () {
          _this2.$message.success('已保存');
          _this2.reload();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      (0, _decoration.decorationReferralRuleActionApi)(row.rule.id, {
        action: action
      }).then(function () {
        _this3.$message.success('已更新');
        _this3.reload();
      });
    }
  }
};